import styled            from 'styled-components/macro'
import { BREAK_ }        from 'constants'
import { Icon }          from 'assets/Icons_'
import { useScalePoint } from 'hooks/useScalePoint' 
import { useBreak }      from 'hooks/useBreak'
import { getFocus, useGet } from 'state/jotai'
import { active_project, iso_isrotating } from 'state/store.global'
import { _bootstrap } from 'state/store.bootstrap'
import { _project } from 'state/store.projects'
import { useEffect, useState } from 'react'

export const Recenter = ({canvasScale, z,bounds,dim,rmode, config}) => {
  const { pin, pid } = useGet(active_project)
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []
  const isMobile    = useBreak('md_dn')
  const SCALE_POINTS = isMobile ? config?.SCALE_POINTS?.MOBILE : config?.SCALE_POINTS?.DESKTOP
  const scale = useScalePoint(bounds,dim,true, '_', isMobile, pin)  + SCALE_POINTS
  const isrotate    = useGet(iso_isrotating);
  const projectType = getFocus(_bootstrap, 'type')

  const [currentScale, setCurrentScale] = useState(z.current?.state?.scale)

  useEffect(()=> {
    setCurrentScale(z.current?.state?.scale)
  }, [dim, scale])

  const click = () => {
    z.current?.zoomToElement('center',scale,200,'easeOut')
    setCurrentScale(scale)
  }

  const props = { projectType, pin, clr, rmode, isrotate, onClick: click, scale, currentScale: currentScale, isMobile }
 
  return (
    <Wrap {...props}>
      <Text className='paragraph1-regular'>{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'NulstilVisning')[0]?.Label }</Text>
      <Icon icon = 'readjust' size = '24' color = {"#004337"}/>
    </Wrap>
  )

}

const Wrap = styled.div`
  border-radius   : 16px;
  background-color: ${({ clr}) => `${clr?.buttons_text}bf`};
  align-items: center;
  gap        : 8px;
  font-size  : 14px;
  width      : fit-content;
  cursor     : pointer;
  ${BREAK_.md_dn} { font-size: 0.6875rem; }
  line-height: 1;
  padding: 5px 8px;
  opacity: ${({ scale, currentScale}) => scale === currentScale ? 0.5 : 1 };
  display: ${({ isMobile, scale, currentScale }) => isMobile && scale === currentScale ? 'none' : 'flex'};
`

const Text = styled.p`
  white-space: nowrap;
  color:#004337;
`